import { useLayoutEffect, useState } from 'react';
import { Size } from 'ff-canvas';

export const useContain = (
    maxSize: Size | undefined,
    aspectRatio: number
) => {

    const [size, setSize] = useState<Size | undefined>();

    useLayoutEffect(() => {
        if (maxSize) {
            setSize({
                width: toCssSize(Math.min(maxSize.width, maxSize.height * aspectRatio)),
                height: toCssSize(Math.min(maxSize.height, maxSize.width / aspectRatio))
            });
        }
    }, [maxSize, aspectRatio]);

    return size;
};

// The browser's layout engine already computed a width/height. Our calculation must match
// the browser's calculation exactly to prevent re-renders.
//
// CSS uses Math.round internally to prevent aliasing, so we must do the same.
const toCssSize = Math.round;